import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../../config/firebase-config';

export const signInUserWithEmailAndPassword = async (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};
